import React from'react'
import {Container} from 'react-bootstrap'
import logo from "../media/Picture1.png"
class ErrorPage extends React.Component {
    constructor(props) {
        super(props)
        this.state ={}

    }
    render() {
        return (
            <Container>
                <h4>Error</h4>
            </Container>
        )
    }
}

export default ErrorPage